module.exports = __webpack_public_path__ + "static/media/purpleTheme-boy.b06b3849.svg";